import { holidaysPageReducer } from '../modules/Holidays/services/reducer';
import { combineReducers } from 'redux';

export const adminCalendarPageReducer = combineReducers({
  holidays: holidaysPageReducer,
});
